import { Action } from '@/_core/fluxstore/types';
import { CurrentUserState } from '../types';
import { useCurrentUserModule } from '../useModule';

const { registerReducer } = useCurrentUserModule();

export class InitCurrentUser extends Action<CurrentUserState> {
    public static ACTION_TYPE = 'InitCurrentUser';

    public constructor() {
        super(InitCurrentUser.ACTION_TYPE);
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const reducer = (state: CurrentUserState, action: InitCurrentUser): void => {
    state.userId = initAppData.currentUser.currentUserId;
    state.userShortId = initAppData.currentUser.currentUserShortId;

    state.fullName = initAppData.currentUser.currentUserFullName;
    state.loginName = initAppData.currentUser.currentUserLoginName;

    state.email = initAppData.currentUser.currentUserEmail;

    state.hasJiraAuthToken = initAppData.currentWs.hasJiraAuthToken;

    state.canCreateWorkspaces = initAppData.currentUser.currentUserCanCreateWorkspaces;

    state.userIsDomainControlled = initAppData.currentUser.currentUserIsDomainControlled;

    state.ssoEnabledForUser = initAppData.currentUser.ssoEnabledForCurrentUser;
    state.ssoRequiredForUser = initAppData.currentUser.ssoRequiredForCurrentUser;

    state.userIpAddress = initAppData.currentUser.currentUserIpAddress;

    state.userSessionId = initAppData.csrf.currentUserSessionId; //TODO: Ez nem hiszem hogy az...

    state.dismissedQuickTipKeys = initAppData.currentUser.dismissedQuickTipKeys;
};

//@ts-ignore
registerReducer(InitCurrentUser.ACTION_TYPE, reducer);
